import { Formik } from "formik";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FormDisplay from "./FormDisplay";
import pages from "../../../constants/pages";
import { useAxios, useAlert } from "../../../hooks";
import { validationSchema, objectFromFormData } from "./brandDetailObject";

export default function Form({
  agencyID,
  list,
  formData,
  editState,
  setEditState,
}) {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  const businessEntityID =
    useSelector((state) => state.memberDetails?.businessEntityID) ||
    sessionStorage.getItem("businessEntityId");

  const reduxAgencyVerified = useSelector(
    (state) => state.memberDetails?.agency?.isAgencyVerified
  );

  const { agency } = useSelector((state) => state.memberDetails);

  const isAgencyVerified = state?.is_agency_verified
    ? state?.is_agency_verified
    : reduxAgencyVerified ?? sessionStorage.getItem("is_agency_verified");

  const agencyName = state?.agencyName ? state?.agencyName : agency?.agencyName;
  const agencyLogo = state?.agencyLogo ? state?.agencyLogo : agency?.agencyLogo;

  const multiBrand = queryString.parse(window.location.search).newMultiBrand;

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(formData, { setSubmitting }) => {
        let url = "/user/brand";
        let method = "POST";

        if (formData.brandID) {
          url = "/user/brand/" + formData.brandID;
          method = "PUT";
        }

        axios({
          url: url,
          method: method,
          data: objectFromFormData(formData, businessEntityID),
          disableRedirect: true,
        })
          .then((res) => {
            if (res.status) {
              if (!formData.brandID) {
                sessionStorage.setItem("brandID", res.data?.brand_id);

                dispatch(
                  alert({
                    message: "Brand created successfully!",
                    type: "success",
                  })
                );

                if (multiBrand) {
                  navigate(pages.welcomePage.route);
                } else {
                  navigate(pages.createWelcomePage.route, {
                    state: {
                      is_agency_verified: isAgencyVerified,
                      agencyName: agencyName,
                      agencyLogo: agencyLogo,
                    },
                  });
                }
              }

              if (!!formData.brandID) {
                dispatch(
                  alert({
                    message: "Brand updated successfully!",
                    type: "success",
                  })
                );
                setEditState(false);
              }
            }
            setSubmitting(false);
          })
          .catch((err) => {
            console.error(err);
          });
      }}
    >
      {(formikProps) => (
        <FormDisplay
          businessEntityID={businessEntityID}
          agencyID={agencyID}
          multiBrand={multiBrand}
          list={list}
          editState={editState}
          formikProps={formikProps}
          setEditState={setEditState}
        />
      )}
    </Formik>
  );
}
